export default class ManageTerritoryBaseFeatureStyleSettingsModule {
    /**
     * 
     * @param styleSettings 
     * @param territoryModel 
     * 
     * @returns 
     */
    getRequiredAttributes(styleSettings, territoryModel): string[] {
        return [];
    }
}
